module.exports = __webpack_public_path__ + "assets/Facebook.c9375838.svg";